"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.create.success': 'Dane slotu zostały utworzone pomyślnie',
    'slotData.create.error': 'Nie udało się utworzyć danych slotu',
};
